import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

const RoleProtectedRoute = ({ children, allowedRoles }) => {
    const { token, user, hasHydrated } = useAuthStore()
    const isAuthenticated = !!token

    if (!hasHydrated) return <div>Loading...</div>
    if (!isAuthenticated) return <Navigate to="/login" replace />

    if (allowedRoles && !allowedRoles.includes(user?.role)) {
        return <Navigate to="/dashboard" replace />
    }

    return children
}

export default RoleProtectedRoute